/* Recently viewed products in the Search drawer.
   Reads the handles main-product.liquid stores in localStorage and renders each
   through the Section Rendering API (sections/search-recently-viewed-render.liquid). */
(() => {
  const group = document.querySelector('[data-search-recently-viewed]');
  const modal = document.getElementById('modal-search');
  if (!group || !modal) return;

  const list = group.querySelector('ul');
  const limit = parseInt(group.dataset.limit, 10) || 4;
  const root = (group.dataset.sectionUrl || '/').replace(/\/$/, '');
  let loaded = false;

  const readHandles = () => {
    try {
      const handles = JSON.parse(localStorage.getItem('recently_viewed') || '[]');
      if (!Array.isArray(handles)) return [];
      const current = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
      return handles.filter((h) => typeof h === 'string' && h && h !== current).slice(0, limit);
    } catch (e) {
      return [];
    }
  };

  const fetchItem = async (handle) => {
    try {
      const res = await fetch(`${root}/products/${encodeURIComponent(handle)}?section_id=search-recently-viewed-render`);
      if (!res.ok) return null;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      return doc.querySelector('li');
    } catch (e) {
      return null;
    }
  };

  const load = async () => {
    if (loaded) return;
    loaded = true;
    const handles = readHandles();
    if (!handles.length) return;
    const items = (await Promise.all(handles.map(fetchItem))).filter(Boolean);
    if (!items.length) return;
    items.forEach((li, i) => {
      li.id = `predictive-search-option-recent-${i + 1}`;
      list.appendChild(li);
    });
    group.classList.remove('hidden');
  };

  modal.addEventListener('modalChanged', (event) => {
    if (event.detail && event.detail.show) load();
  });
  if (modal.hasAttribute('open')) load();
})();
